import { Language } from "../types/language";
import { Timeline } from "../types/timeline";

export interface IHttpResponse extends Response {
	parsedBody?:  Timeline<Language>;
}

class TimelineService {
    private baseUrl : string | undefined;
    private year : string | undefined;
    private code : string[] | undefined;

    public constructor(url: string, year : string, code : string[]) {
        this.baseUrl = url;
        this.year = year;
        this.code = code;
    }

  	getTimelines = () : Promise<IHttpResponse> => {
		return new Promise((resolve, reject) => {
			let response : IHttpResponse;
			const url = this.baseUrl + "/api/maintenance-timeline/details";

			fetch(url, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body : JSON.stringify({year : this.year, code : this.code })})
				.then(res => {
					response = res;
					return res.json();
				})
				.then(body => {
					if(response.ok) {
						const parsedBody = body;
                        response.parsedBody = parsedBody;
						resolve(response);
					}
					else {
						reject(response);
					}
				})
				.catch(err => {
					reject(err);
				});
		});
  	}
}

export default TimelineService;
